import { useEffect, useRef, useState } from "react";

export function useThrottle<T>(value: T, interval = 1000): T {
  const [throttledValue, setThrottledValue] = useState<T>(value);
  const lastExecuted = useRef<number>(Date.now());

  useEffect(() => {
    if (Date.now() >= lastExecuted.current + interval) {
      lastExecuted.current = Date.now();
      setThrottledValue(value);
    } else {
      const timerId = setTimeout(() => {
        lastExecuted.current = Date.now();
        setThrottledValue(value);
      }, interval - (Date.now() - lastExecuted.current));

      return () => clearTimeout(timerId);
    }
  }, [value, interval]);

  return throttledValue;
}